import { SVG_ENUM } from "enums";
import SVG from "shared/SVG";
import ContextMenu from "shared/ContextMenu";
import { InvestmentTransactionType } from "hooks/investments/GetInvestmentTransactionsHook";

export const TYPE_LABELS: Record<string, string> = {
  buy: "Zakup",
  sell: "Sprzedaż",
};

export const INTEREST_TYPE_LABELS: Record<string, string> = {
  fixed: "Stałe",
  variable: "Zmienne",
  periodically_fixed: "Okresowo-stałe",
};

export const formatDate = (dateStr: string | null | undefined): string => {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("pl-PL", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const formatNumber = (value: number | undefined | null): string => {
  if (value === null || value === undefined) return "—";
  const num = Number(value);
  return num.toLocaleString("pl-PL", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

export const FileCell = ({ tx }: { tx: InvestmentTransactionType }) =>
  tx.file?.url ? (
    <a
      href={tx.file.url}
      target="_blank"
      rel="noreferrer"
      className="itm-table__file-link"
      title={tx.file.name ?? "Pobierz umowę"}
    >
      <SVG type={SVG_ENUM.FILE} />
    </a>
  ) : (
    <>{"brak"}</>
  );

export const DotsMenu = ({
  tx,
  onEdit,
}: {
  tx: InvestmentTransactionType;
  onEdit?: () => void;
}) => (
  <ContextMenu
    data={tx}
    items={onEdit ? [{ name: "Edytuj", action: () => onEdit() }] : []}
  >
    <SVG type={SVG_ENUM.DOTS} />
  </ContextMenu>
);
